import { render, staticRenderFns } from "./info-page2.vue?vue&type=template&id=449e3dca&"
import script from "./info-page2.vue?vue&type=script&lang=js&"
export * from "./info-page2.vue?vue&type=script&lang=js&"
import style0 from "./info-page2.vue?vue&type=style&index=0&id=449e3dca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports